import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Popup } from 'semantic-ui-react'

import rate from './rate'
import RatingDetail from './RatingDetail'
import RatingStar from './RatingStar'

class Rate extends PureComponent {
  render() {
    const { className, onRate, readOnly, total1, total2, total3, total4, total5 } = this.props

    const rating = rate(total1, total2, total3, total4, total5)

    return (
      <div className={className}>
        <Popup
          className="*:p-2"
          content={<RatingDetail total1={total1} total2={total2} total3={total3} total4={total4} total5={total5} />}
          on={['hover', 'click', 'focus']}
          trigger={
            <RatingStar
              disabled={readOnly}
              onRate={onRate}
              value={rating}
              votes={total1 + total2 + total3 + total4 + total5}
            />
          }
        />
      </div>
    )
  }
}

Rate.propTypes = {
  onRate: PropTypes.func.isRequired,

  className: PropTypes.string,
  readOnly: PropTypes.bool,
  total1: PropTypes.number,
  total2: PropTypes.number,
  total3: PropTypes.number,
  total4: PropTypes.number,
  total5: PropTypes.number,
}

Rate.defaultProps = {
  className: null,
  readOnly: false,
  total1: 0,
  total2: 0,
  total3: 0,
  total4: 0,
  total5: 0,
}

export default Rate
